// extracted by mini-css-extract-plugin
export default {"resetButton":"c8145CB","root":"C7Jb5jA","dsl":"UddUdYr"};